<div class="sidebar included">
	<app-sidebar-header [title]="_printTitle">
		<div custom-label *ngIf="_hasFrequentFlyer">
			<app-svg classes="logo__booking-loyalty-program PAX" [ngClass]="_logoClasses" 
				alt="Miles&Go - {{ passengerInfo.tierLevelFF }} logo"
				svg="sprite.svg#{{ _getLoyaltyLogo }}" aria-hidden="true">
			</app-svg>
		</div>
	</app-sidebar-header>

	<div *ngIf="isPassengersInfoLoaded && passengersLength > 1" class="sidebar-subheader">
		<div class="passenger-chooser align-right">
			<a class="link" (swipe)="INDRA_handleNextPassenger()"
				(click)="INDRA_handleNextPassenger()" href="javascript:;" role="button">
				{{'bookingDetails.link.nextPassenger' | ibeadmin:'sync'}} ({{INDRA_nextPassengerCountLabel()}})
			</a>
		</div>
	</div>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="sidebar-flight" *ngFor="let flightItem of flights; let x = index" [id]="'flightItem-' + flightItem.assignedFlightId">
			<div class="sidebar-flight-header">
				<app-flight-route class="app-flight-route--clean" [flight]="flightItem"></app-flight-route>
			</div>
			<div class="sidebar-flight-extras">
				<ul class="body">
					<li *ngFor="let feature of flightFeatures[x]; let i = index" class="extras-feature">
						<ng-container *ngIf="!(feature.id=== 'Miles' && passengerInfo.typePax==='INF')">
							<app-svg [ngClass]="['extras-feature__icon']" 
								svg="icons.svg#{{feature.icon || 'general--plus'}}"
								[alt]="feature.label + ' icon'">
							</app-svg>
							<div class="extras-feature__label">
								<span>
									<span *ngIf="feature.tierValueLabel">{{feature.tierValueLabel}}</span>
									<span *ngIf="!feature.tierValueLabel && feature.valueLabel">{{feature.valueLabel}}</span>
									{{feature.label | async}}
								</span>
								<span class="muted-light">
									{{feature.description}} 
									<span *ngIf="INDRA_displayFeatureDescriptionSuffix(feature)"> 
										{{INDRA_printFeatureDescriptionSuffix(feature)}}
									</span>
								</span>
							</div>
							<!--
							<button *ngIf="feature.action&&display" (click)="TAP_handleFeatureClick(feature.action, flight)"
								class="button button--small extras-feature__button"
								[attr.aria-label]="'Open dialog to ' + feature.action.label">{{feature.action.label}}</button>
							-->	
							<a *ngIf="feature.details && display" 
								(click)="INDRA_handleFeatureClick(feature.details, flightItem)" 
								class="text-link extras-feature__link" 
								[attr.aria-label]="('bookingDetails.aria.openDialogTo' | ibeadmin | async) + feature.details.label">
								{{feature.details.label | async}}
							</a>
						</ng-container>
					</li>
				</ul>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" [attr.aria-label]="'bookingDetails.paxIncluded.text.closeDialog' | ibeadmin | async" 
					(click)="INDRA_handleClose()" href="javascript:;"
					role="button">
					{{ 'bookingDetails.paxIncluded.text.closeThisWindow' | ibeadmin | async }}
				</a>
			</p>
		</div>
	</div>
</div>
